import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ContentFloodHero from "../../../../V2/Heroes/Content/FloodHero"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokContentFloodHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ContentFloodHero>) => {
  const calloutItems = blok.callout?.map((item) => ({
    text: item.text,
    highlightedWord: item.highlightedWord,
    highlightColor: item.highlightColor,
    hasBorder: item.hasBorder,
    hasIcon: item.hasIcon,
    iconAlt: item.icon?.alt,
    iconUrl: item.icon?.filename,
    iconColor: item.iconColor,
    ctaText: item.ctaText,
    ctaLink: storyblokLinkToYocoLink(item.ctaLink),
  }))

  return (
    <ContentFloodHero
      backgroundColor={blok.backgroundColor}
      primaryButtonBorderColor={blok.primaryCTAColor}
      superscriptText={blok.superscriptText}
      bodyText={blok.bodyText}
      headingText={blok.headingText}
      headingSize={blok.headingSize}
      headingMobileAlignment={blok.headingMobileAlignment}
      imageAlt={blok.image.alt}
      imageUrl={blok.image.filename}
      mobileImageAlt={blok.mobileImage?.alt}
      mobileImageUrl={blok.mobileImage?.filename}
      primaryButtonLink={storyblokLinkToYocoLink(blok.primaryCTALink)}
      primaryButtonMobileLink={storyblokLinkToYocoLink(
        blok.primaryCTAMobileLink
      )}
      primaryButtonText={blok.primaryCTAText}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      secondaryButtonLink={storyblokLinkToYocoLink(blok.secondaryCTALink)}
      secondaryButtonText={blok.secondaryCTAText}
      videoUrl={
        blok.video?.filename ??
        storyblokLinkToYocoLink(blok.videoUrl)?.url ??
        ""
      }
      callout={calloutItems?.[0]}
      hasScrollArrow={blok.hasScrollArrow}
      hideMobileStickyButton={blok.hideMobileStickyButton}
      secondaryTrackingEvent={blok.secondaryTrackingEvent}
      secondaryTrackingEventKey={blok.secondaryTrackingEventKey}
      secondaryTrackingEventValue={blok.secondaryTrackingEventValue}
      numberCallout={
        blok.numberCallout?.[0]
          ? {
              ...blok.numberCallout[0],
              icon: blok.numberCallout[0].icon?.filename,
            }
          : undefined
      }
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokContentFloodHero
